import { createStore } from "vuex"
import ApiRequest from "@/helpers/ApiRequest.js";

const store = createStore({
    state() {
        return {
            token: sessionStorage.getItem('accessToken') || '',
            companyId: sessionStorage.getItem('companyId') || '',
            permissions: []
        }
    },

    getters: {
        hasPermission: (state) => (permission) => {
            if (permission == null || permission === '') return true
            return state.permissions.includes(permission)
        }
    },

    mutations: {
        setToken(state, token) {
            state.token = token
            sessionStorage.setItem('accessToken', token)
        },

        setCompanyId(state, companyId) {
            state.companyId = companyId
            if (companyId) {
                sessionStorage.setItem('companyId', companyId)
            } else {
                sessionStorage.removeItem('companyId')
            }
        },

        setPermissions(state, permissions) {
            state.permissions = Array.isArray(permissions) ? permissions : []
        }
    },

    actions: {
        initStore({ commit }) {
            commit('setToken', sessionStorage.getItem('accessToken') || '')
            commit('setCompanyId', sessionStorage.getItem('companyId') || '')
        },

        async checkPermission({ commit }) {
            if (!sessionStorage.getItem("accessToken")) return

            try {
                const { data } = await ApiRequest.requestAsync(
                    'user/permissions',
                    ApiRequest.REQUEST_GET,
                    []
                )

                commit('setPermissions', data?.permissions || [])
            } catch (error) {
                console.error('Failed to fetch permissions', error)
            }
        }
    }
})

export default store